export default __webpack_public_path__ + "static/media/myTeamOnboarding.6434b455.png";